<main class="profile">
    <div class="profile-bg"></div>
    <section class="container">
        <aside class="profile-image">
            <a class="camera" href="#">
                <i class="fas fa-camera"></i>
            </a>
        </aside>
        <section class="profile-info">
            <h1 class="first-name">Ben Karoum </h1>
            <h1 class="second-name">Issam</h1>
            <h2>ABOUT</h2>
            <div>

                <div class="row">

                    <div class="col-md-6">
                        <p> <b> Nom et Prénom </b></p>
                        <p>BEN KAROUM ISSAM</p>
                    </div>
                    <div class="col-md-6">
                        <p> <b> Email </b></p>
                        <p>i.benkaroum@stg.ma</p>
                    </div>
                    <div class="col-md-6">
                        <p> <b> Role </b></p>
                        <p>Admin</p>
                    </div>

                    <div class="col-md-6">
                        <p> <b> Propriétaire </b></p>
                        <p>STG</p>
                    </div>

                </div>

            </div>

        </section>
    </section>
    <section class="statistics">
        <button class="icon arrow left"></button>
        <button class="icon arrow right"></button>
        <p><strong>29</strong> Véhicules</p>
        <p><strong>184</strong> Conducteurs</p>
        <p><strong>6</strong> Evénements</p>
    </section>
    <button class="icon close"></button>
</main>

